import React from "react";

import "./style.css";

import csc from "./volunteerImages/csc.jpg";
import iot from "./volunteerImages/iot.jpg";

export default function VolunteerExperienceComponent() {
  return (
    <div>
      <div class="heading">
        <h2 class="text-center">Volunteer Experience</h2>
      </div>
      <div className="row VolunteerExperienceRow">
        <div className="col-md-6 col-sm-12">
          <img src={csc} className="img-fluid" />
        </div>
        <div
          className="col-md-6 col-sm-12 VolunteerExperienceCol"
          style={{ marginTop: "10%" }}
        >
          I participated as a presenter for the Cloud Skills Challenge Closing
          Event and share my experiences with others
        </div>
      </div>
      <div className="row VolunteerExperienceRow">
        <div className="col-md-6 col-sm-12">
          <img src={iot} className="img-fluid" />
        </div>
        <div
          className="col-md-6 col-sm-12 VolunteerExperienceCol"
          style={{ marginTop: "10%" }}
        >
          I shared my knowledge and hands-on experience of what NodeMcu is and
          its use in IoT during the cloud skill webinar organized by ms club of
          SLIIT
        </div>
      </div>
      <div className="row VolunteerExperienceRow">
        <div className="col-md-6 col-sm-12">
          {" "}
          <img
            src="https://firebasestorage.googleapis.com/v0/b/senurajayadeva-394f1.appspot.com/o/1604218125119.jpg?alt=media&token=bfc06445-54ff-4fba-a129-97d9a8dcae32"
            className="img-fluid"
          />
        </div>
        <div className="col-md-6 col-sm-12 VolunteerExperienceCol">
          I participated as a presenter for the return Cero workshop which was
          organized by the Ms club for first-year students and I explained
          fundamentals of the C with a past paper question
        </div>
      </div>
    </div>
  );
}
